import "@/styles/globals.css";
import '../styles/autofill-fix.css';
import "@livekit/components-styles";
import "@livekit/components-styles/prefabs/index.css";
import { AuthProvider } from '../components/AuthContext';
import { ThemeProvider } from '../components/ThemeProvider';
import { LanguageProvider } from '../contexts/LanguageContext';
import { FeedbackProvider } from '../contexts/FeedbackContext';
import ProfessionalGuideGate from '../components/ProfessionalGuideGate';
import AdminButton from '../components/AdminButton';
import { useEffect } from 'react';
import Head from 'next/head';
import GlobalErrorBoundary from '../components/GlobalErrorBoundary';

export default function App({ Component, pageProps }) {
  useEffect(() => {
    // Remover service workers e caches
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister());
      });
    }

    if ("caches" in window) {
      caches.keys().then((keys) => {
        keys.forEach((key) => caches.delete(key));
      });
    }
  }, []);

  return (
    <>
      <Head>
        <title>KalonConnect | Tecnologia com Alma para seus Atendimentos</title>
        <meta name="description" content="KalonConnect é a plataforma definitiva para terapeutas e profissionais de saúde, oferecendo consultas seguras, registros inteligentes e gestão completa com alma." />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=5" />
        <meta name="theme-color" content="#093b3e" />
        <link rel="icon" href="/favicon.ico" />
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.kalonconnect.com/" />
        <meta property="og:title" content="KalonConnect | Tecnologia com Alma" />
        <meta property="og:description" content="Consultas seguras e gestão inteligente para profissionais de saúde e bem-estar." />
        <meta property="og:image" content="https://www.kalonconnect.com/og-image.png" />
      </Head>
      <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <GlobalErrorBoundary>
            <FeedbackProvider>
              <ProfessionalGuideGate>
                <Component {...pageProps} />
                <AdminButton />
              </ProfessionalGuideGate>
            </FeedbackProvider>
          </GlobalErrorBoundary>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
    </>
  );
}
